module.exports = __webpack_public_path__ + "static/media/5.27792207.jpg";